import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";
import {
  GenerateGenieDocumentSuiteInput,
  GenerateGenieDocumentSuiteResult,
} from "@/types/genie-documents/genie-document";

/**
 * Generate a whole suite of branded documents from the owner's approved
 * proposals — the swarm's drafting step. Saves each as an unpublished draft and
 * refreshes the documents list so the new cards appear.
 */
export const useGenerateGenieDocumentSuite = () => {
  const queryClient = useQueryClient();

  return useMutation<GenerateGenieDocumentSuiteResult, Error, GenerateGenieDocumentSuiteInput>({
    mutationFn: async (input) =>
      ApiService.invoke<GenerateGenieDocumentSuiteResult>({
        resource: "genie-documents",
        action: "generate-suite",
        data: { agentId: input.agentId, suite: input.suite },
      }),
    onSuccess: () => {
      // New documents are real `documents` rows — invalidate the library lists.
      queryClient.invalidateQueries({ queryKey: ["documents"] });
      queryClient.invalidateQueries({ queryKey: ["documents-infinite"] });
      queryClient.invalidateQueries({ queryKey: ["knowledge-base-docs"] });
    },
  });
};
